import { Location } from '@angular/common';
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { SettingsHttpService } from '../../../../../app/core/settings';
import { of } from 'rxjs';
import { MixpanelService } from '../../../../../app/services/mixpanel.service';
import { PRICING_TEMPLATES, PRICING_TEMPLATE_LABELS } from './pricing-templates.constants';
var PriceChangeComponent = /** @class */ (function () {
    // trackByIndex(index: number, item: any) {
    // 	return index;
    //   }
    // priceChange = {
    // 	machine_id: "",
    // 	updated_by: "Karthik@bluesparq.com",
    // 	updated_at: "2023-09-11T10:23:45Z",
    // 	applied_at: "2023-09-11T11:05:45Z",
    // 	recipes: [
    // 		{
    // 			name: 'Americano',
    // 			recipeId: '',
    // 			oldPrice: 3.49,
    // 			price: 2
    // 		},
    // 		{
    // 			name: 'Mocha',
    // 			recipeId: '',
    // 			oldPrice: 3.49,
    // 			price: 2
    // 		}
    // 	]
    // };
    // 	machine_id,name,recipeId,oldPrice,price
    // machine_id,updated_by,updated_at,applied_at
    function PriceChangeComponent(location, http, _snackBar, cdr, mixpanelService, route, machineRouteService) {
        this.location = location;
        this.http = http;
        this._snackBar = _snackBar;
        this.cdr = cdr;
        this.mixpanelService = mixpanelService;
        this.route = route;
        this.machineRouteService = machineRouteService;
        this.rawRecipes = '';
        this._recipes = null;
        this._allRecipes = null; // Store all recipes including hot water
        this.appliedPricingTemplate = null;
        this.priceChange = {
            machine_id: "",
            updated_by: " ",
            updated_at: " ",
            applied_at: null,
            recipes: [{
                    recipeId: "",
                    name: "",
                    oldPrice: 0,
                    price: null
                }]
        };
    }
    PriceChangeComponent.prototype.ngOnInit = function () {
        this.selectedMachine = this.machineRouteService.getMachine(this.route);
        if (!this.selectedMachine)
            return;
        this.machineId = this.selectedMachine.machine_id;
        this.serial_no = this.selectedMachine.serial_no;
        this.getPriceChange();
        this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
            machineName: this.selectedMachine.machine_name,
            machineId: this.selectedMachine.machine_id,
            serialNo: this.selectedMachine.serial_no
        });
    };
    PriceChangeComponent.prototype.onBack = function () {
        this.location.back();
        // this.priceChange.recipes[0].price = 5;
    };
    Object.defineProperty(PriceChangeComponent.prototype, "appliedTemplateLabel", {
        get: function () {
            return this.appliedPricingTemplate ? PRICING_TEMPLATE_LABELS[this.appliedPricingTemplate] : '';
        },
        enumerable: true,
        configurable: true
    });
    PriceChangeComponent.prototype.applyPricingTemplate = function (templateId) {
        if (!this._recipes) {
            return;
        }
        var prices = PRICING_TEMPLATES[templateId];
        this._recipes.forEach(function (item) {
            if (prices[item.name] != null) {
                item.price = prices[item.name];
            }
        });
        this.appliedPricingTemplate = templateId;
        this.cdr.detectChanges();
    };
    PriceChangeComponent.prototype.clearPrices = function () {
        if (!this._recipes) {
            return;
        }
        this._recipes.forEach(function (item) { return item.price = null; });
        this.appliedPricingTemplate = null;
        this.cdr.detectChanges();
    };
    PriceChangeComponent.prototype.getPriceChange = function () {
        var _this = this;
        // this.priceloading = true;
        this.priceChangeObservable$ = this.http.getPriceChange(this.machineId);
        // this.http.getPriceChange(this.machineId)
        this.priceChangeObservable$.subscribe(function (priceChange) {
            if (priceChange && priceChange.recipes) {
                _this._allRecipes = priceChange.recipes; // Store all recipes
                // Filter out hot water for display
                _this._recipes = priceChange.recipes.filter(function (item) {
                    var name = (item.name || '').toLowerCase().trim();
                    return name !== 'hot water';
                });
                // Store raw recipes without hot water for change detection
                _this.rawRecipes = JSON.stringify(_this._recipes);
                _this.priceChange = priceChange;
                _this.cdr.detectChanges();
                // this.priceloading = false;
            }
        });
    };
    PriceChangeComponent.prototype.onSubmit = function () {
        // Check if any of the new prices are empty
        // <<<<<<< Updated upstream
        // 	// const hasEmptyPrice = this._recipes.some(item => !item.price);
        // 	const hasEmptyPrice = this._recipes.some(item => !item.price.trim());
        var _this = this;
        // =======
        // const hasEmptyPrice = this._recipes.some(item => !(item.price.toString().trim()) || isNaN(item.price));
        // >>>>>>> Stashed changes
        var hasEmptyPrice = this._recipes.some(function (item) {
            if (item.price == null || item.price == undefined) {
                return true;
            }
            var priceString = item.price.toString().trim();
            return priceString === '' || isNaN(item.price);
        });
        if (hasEmptyPrice) {
            // Show a snackbar message if there is an empty price
            this.showSnackBar('Price cannot be empty', 3000);
            return;
        }
        // If no empty prices, proceed with submitting the data
        if (JSON.stringify(this._recipes) !== this.rawRecipes) {
            // Get original hot water recipe (if it exists)
            var hotWaterRecipe = this._allRecipes && this._allRecipes.find(function (item) {
                var name = (item.name || '').toLowerCase().trim();
                return name === 'hot water';
            });
            // Merge visible recipes with hot water (preserving its original value)
            var recipesToSubmit = this._recipes.slice();
            if (hotWaterRecipe) {
                recipesToSubmit.push(hotWaterRecipe);
            }
            var updateRequest = {
                machine_id: this.priceChange.machine_id,
                serial_no: this.serial_no,
                updated_by: this.priceChange.updated_by,
                updated_at: this.priceChange.updated_at,
                applied_at: this.priceChange.applied_at,
                recipes: recipesToSubmit
            };
            this.http.updateMenuPrices(updateRequest).subscribe(function (result) {
                // Update the UI with the result from the API
                if (result && result.recipes) {
                    _this._allRecipes = result.recipes; // Store all recipes
                    // Filter out hot water for display
                    _this._recipes = result.recipes.filter(function (item) {
                        var name = (item.name || '').toLowerCase().trim();
                        return name !== 'hot water';
                    });
                    // Store raw recipes without hot water for change detection
                    _this.rawRecipes = JSON.stringify(_this._recipes);
                    _this.priceChange = result;
                    // Update the observable so the template refreshes
                    _this.priceChangeObservable$ = of(result);
                    _this.cdr.detectChanges();
                    _this.showSnackBar('Prices updated successfully', 3000);
                }
            }, function (error) {
                // Handle error if needed
                console.error('Error updating prices:', error);
                _this.showSnackBar('Failed to update prices', 3000);
            });
            //   console.log(this.priceChange.recipes);
        }
        else {
            this.showSnackBar("No Changes were made.", 3000);
        }
    };
    PriceChangeComponent.prototype.showSnackBar = function (message, duration) {
        var _this = this;
        var snackRef = this._snackBar.open(message, 'close');
        if (duration > 0) {
            setTimeout(function () {
                _this._snackBar.dismiss();
            }, duration);
        }
        snackRef.onAction().subscribe(function () {
            _this._snackBar.dismiss();
        });
    };
    return PriceChangeComponent;
}());
export { PriceChangeComponent };
